<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["voucher"] }}</p>
      </div>
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["enter_voucher_code"] }}
      </p>
      <input
        type="text"
        v-model="code"
        :placeholder="this.$store.getters.TRANSLATIONS['code']"
        class="code"
        autocomplete="off"
      />
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="add()" class="button">
        {{ this.$store.getters.TRANSLATIONS["add"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: "",
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      add: () => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(
            `${process.env.SERVER_URL}/7C14E244F42040D2A1D080B97CA9CA1D/${this.code}`,
            {},
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Associate voucher response:");
            console.log(response);
            if (response && response.status === 200) {
              this.$router.push("/marketCampagnsList");
            } else {
              throw "error";
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["code_not_valid"];
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK"
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      back: () => {
        this.$router.go(-1);
      },
      icon: require("@/assets/icon_back.png")
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
input {
  margin: 0px 17vw 3vh;
  width: 65%;
  float: left;
  background: transparent;
  color: rgba(114, 174, 255, 1);
  border: 0;
  outline: 0;
  border-bottom: 1px solid rgba(114, 174, 255, 1);
}
input::placeholder {
  color: rgba(114, 174, 255, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/MarketingCampaignVouchers/Add.vue